import Container from '../common/container';
import Image from '~/components/common/image';
import { NextLink, Translate, useTranslate } from '~/i18n';
/******************************************************************
 *
 *  THIS COMPONENT WAS GENERATED BY NEXTCRAZY-CLI
 *
 ******************************************************************/

const OurAwards = () => {
   const { dir } = useTranslate();

   return (
      <Container>
         <div className="max-w-5xl mx-auto my-24 ">
            <div className="max-w-2xl mx-auto ">
               <div className="mb-16 text-center">
                  <span className="mx-auto text-4xl font-bold">
                     <Translate id="about:our awards" />
                  </span>
               </div>

               <ul className="flex flex-col items-center justify-between space-y-8 xs:space-y-0 xs:flex-row">
                  <li className="flex items-center justify-center">
                     <Image
                        src="/images/about-page/Forbes-1.png"
                        height="71px"
                        width="182px"
                        className="object-contain"
                     />
                  </li>
                  <li className="flex items-center justify-center">
                     <Image
                        src="/images/about-page/uxbert-gitex.png"
                        height="112px"
                        width="95px"
                        className="object-contain"
                     />
                  </li>
                  <li className="flex items-center justify-center">
                     <Image
                        src="/images/about-page/uxbert-smashingmag3.png"
                        height="107px"
                        width="91px"
                        className="object-contain"
                     />
                  </li>
                  <li className="flex items-center justify-center">
                     <Image
                        src="/images/about-page/uxbert-forbes.png"
                        height="107px"
                        width="91px"
                        className="object-contain"
                     />
                  </li>
               </ul>
            </div>
            <div className="mb-16 text-center mt-28">
               <span className="mx-auto text-4xl font-bold">
                  <Translate id="about:discover engagement platform" />
               </span>
            </div>
            <ul className="grid flex-wrap items-center justify-center gap-y-16 sm:gap-y-0 small:grid-cols-2 sm:flex">
               <li className="flex flex-col items-center justify-center text-center sm:m-8">
                  <div className="mb-6">
                     <a href="https://www.agool.app/index_en.html" target="_blank" rel="noreferrer">
                        <Image
                           src="/images/about-page/agool.svg"
                           width="87px"
                           height="40px"
                           className="object-contain "
                        />
                     </a>
                  </div>
                  <span className="text-xs font-light text-pr">
                     <Translate id="about:discover and chat" />
                  </span>
               </li>
               <li className="flex flex-col items-center justify-center text-center sm:m-8">
                  <div className="mb-6">
                     <a
                        href="https://play.google.com/store/apps/details?id=com.uxbert.hykoora"
                        target="_blank"
                        rel="noreferrer">
                        <Image
                           src="/images/about-page/koora.svg"
                           width="87px"
                           height="40px"
                           className="object-contain "
                        />
                     </a>
                  </div>
                  <span className="text-xs font-light text-pr">
                     <Translate id="about:sports tournaments" />
                  </span>
               </li>
               <li className="flex flex-col items-center justify-center text-center sm:m-8">
                  <div className="mb-6">
                     <a href="https://gsa.live/en" target="_blank" rel="noreferrer">
                        <Image
                           src="/images/about-page/gsa.svg"
                           width="87px"
                           height="40px"
                           className="object-contain "
                        />
                     </a>
                  </div>
                  <span className="text-xs font-light text-pr">
                     <Translate id="about:live streaming" />
                  </span>
               </li>
               <li className="flex flex-col items-center justify-center text-center sm:m-8">
                  <div className="mb-6">
                     <NextLink href="">
                        <Image
                           src="/images/about-page/hy-dark-logo.svg"
                           width="87px"
                           height="40px"
                           className="object-contain "
                        />
                     </NextLink>
                  </div>
                  <span className="text-xs font-light text-pr">
                     <Translate id="about:sports and entertainment communities" />
                  </span>
               </li>
               <li className="flex flex-col items-center justify-center text-center sm:m-8">
                  <div className="mb-6">
                     <a href="https://kafugames.com/en" target="_blank" rel="noreferrer">
                        <Image
                           src="/images/about-page/kafu.svg"
                           width="87px"
                           height="40px"
                           className="object-contain "
                        />
                     </a>
                  </div>
                  <span className="text-xs font-light text-pr">
                     <Translate id="about:gaming and sports" />
                  </span>
               </li>
               <li className="flex flex-col items-center justify-center text-center sm:m-8">
                  <div className="mb-6">
                     <a href="https://jazeel.halayalla.com/en" target="_blank" rel="noreferrer">
                        <Image
                           src="/images/about-page/jazeel.svg"
                           width="87px"
                           height="40px"
                           className="object-contain "
                        />
                     </a>
                  </div>
                  <span className="text-xs font-light text-pr">
                     <Translate id="about:influencer and viral marketing" />
                  </span>
               </li>
               <li className="flex flex-col items-center justify-center text-center sm:m-8">
                  <div className="mb-6">
                     <a
                        href="https://tickets.halayalla.com/en_US/home"
                        target="_blank"
                        rel="noreferrer">
                        <Image
                           src="/images/about-page/hy-tickets-logo.png"
                           width="87px"
                           height="40px"
                           className="object-contain "
                        />
                     </a>
                  </div>
                  <span className="text-xs font-light text-pr">
                     <Translate id="about:sports and entertainment tickets" />
                  </span>
               </li>
               <li className="flex flex-col items-center justify-center text-center sm:m-8">
                  <div className="mb-6">
                     <a href="https://sharek.sa/en" target="_blank" rel="noreferrer">
                        <Image
                           src="/images/about-page/sharek.svg"
                           width="87px"
                           height="40px"
                           className="object-contain "
                        />
                     </a>
                  </div>
                  <span className="text-xs font-light text-pr">
                     <Translate id="about:interactive sports platform" />
                  </span>
               </li>
               {/* <li className="flex flex-col items-center justify-center text-center sm:m-8">
                  <div className="mb-6">
                     <Image
                        src="/images/about-page/abad-logo.png"
                        width="87px"
                        height="40px"
                        className="object-contain "
                     />
                  </div>
                  <span className="text-xs font-light text-pr">
                     <Translate id="about:gaming and vr" />
                  </span>
               </li> */}
               <li className="flex flex-col items-center justify-center text-center sm:m-8">
                  <div className="mb-6">
                     <a href="https://uxbert.com/" target="_blank" rel="noreferrer">
                        <Image
                           src="/images/about-page/ux-labs-logo.png"
                           width="100%"
                           height="40px"
                           className="object-contain "
                        />
                     </a>
                  </div>
                  <span className="text-xs font-light text-pr">
                     <Translate id="about:ux usability ecom" />
                  </span>
               </li>
               <li className="flex flex-col items-center justify-center text-center sm:m-8">
                  <div className="mb-6">
                     <a href="https://sportsforall.com.sa/" target="_blank" rel="noreferrer">
                        <Image
                           src="/images/about-page/sfa.svg"
                           width="87px"
                           height="40px"
                           className="object-contain "
                        />
                     </a>
                  </div>
                  <span className="text-xs font-light text-pr">
                     <Translate id="about:sports community" />
                  </span>
               </li>
            </ul>
         </div>
         <div className="mb-24">
            {dir === 'ltr' ? (
               <img
                  className="m-auto"
                  src="/images/about-page/community-en.png"
                  width="600px"
                  height="600px"
               />
            ) : (
               <img
                  className="m-auto"
                  src="/images/about-page/community-ar.png"
                  width="600px"
                  height="600px"
               />
            )}
         </div>
      </Container>
   );
};

export default OurAwards;
